import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { EndpointKey } from '../../http/EndpointKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
export const getGTKMEndpointKey = state => {
  const getIsAssignedToACQ175VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0175, [ExperimentParameterGroup.Variant_A]);
  const getIsAssignedToACQ175VariantC = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0175, [ExperimentParameterGroup.Variant_C]);
  const getIsAssignedToACQ177VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);

  // we hope to keep the logic of ACQ177 Variant A and ACQ175 Variant C totally the same
  if (getIsAssignedToACQ177VariantA || getIsAssignedToACQ175VariantC) {
    return EndpointKey.GTKMCompanyInfoACQ177;
  } else if (getIsAssignedToACQ175VariantA) {
    return EndpointKey.GTKMCompanyInfoACQ175;
  }
  return EndpointKey.GTKMCompanyInfo;
};